import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './Status.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Status extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isShowStatus: false,
			statusType: null,
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.status !== this.props.status) {
			this.setStatus();
		}
	}

	setStatus = () => {
		let isShowStatus = this.state.isShowStatus;
		let status = this.props.status;
		let statusType = this.state.statusType;

		// if Arts Organisation
		if (this.props.isLoggedinUser) {
			if (status.maintenance.upcoming.length > 0) {
				status.maintenance.upcoming[0].containers_affected.forEach((container_affected) => {
					if (container_affected.name === 'Arts Organization Services') {
						isShowStatus = true;
						statusType = 'upcoming';
					}
				});
			}

			if (status.maintenance.active.length > 0) {
				status.maintenance.active[0].containers_affected.forEach((container_affected) => {
					if (container_affected.name === 'Arts Organization Services') {
						isShowStatus = true;
						statusType = 'active';
					}
				});
			} 

			if (status.incidents.length > 0) {
				status.incidents[0].containers_affected.forEach((container_affected) => {
					if (container_affected.name === 'Arts Organization Services') {
						isShowStatus = true;
						statusType = 'incident';
					}
				});
			}
		} else {
			// If Patrons
			if (status.maintenance.upcoming.length > 0) {
				status.maintenance.upcoming[0].containers_affected.forEach((container_affected) => {
					if (container_affected.name === 'Patron Services') {
						isShowStatus = true;
						statusType = 'upcoming';
					}
				});
			}
			
			if (status.maintenance.active.length > 0) {
				status.maintenance.active[0].containers_affected.forEach((container_affected) => {
					if (container_affected.name === 'Patron Services') {
						isShowStatus = true;
						statusType = 'active';
					}
				});
			}
			
			if (status.incidents.length > 0) {
				status.incidents[0].containers_affected.forEach((container_affected) => {
					if (container_affected.name === 'Patron Services') {
						isShowStatus = true;
						statusType = 'incident';
					}
				});
			}
		}
		this.setState({
			isShowStatus,
			statusType,
		});
	}

	closeStatus = () => {
		let isShowStatus = this.state.isShowStatus;
		isShowStatus = false;
		this.setState({
			isShowStatus,
		});
	}

	renderTitle = () => {
		let statusType = this.state.statusType;
		let title = '';
		if (statusType === 'incident') {
			title = this.props.status.incidents[0].name;
			return `${title}: `;
		}
		if (statusType === 'active') {
			title = this.props.status.maintenance.active[0].name;
			return `${title}: `;
		}
		if (statusType === 'upcoming') {
			title = this.props.status.maintenance.upcoming[0].name;
			return `${title}: `;
		}
	}

	renderMessage = () => {
		let statusType = this.state.statusType;
		let message = '';
		if (statusType === 'incident') {
			message = this.props.status.incidents[0].messages[this.props.status.incidents[0].messages.length-1].details;
			return `${message} - ${moment.utc(this.props.status.incidents[0].messages[this.props.status.incidents[0].messages.length-1].details.datetime).format('LLLL')} UTC`;
		}
		if (statusType === 'active') {
			message = this.props.status.maintenance.active[0].messages[this.props.status.maintenance.active[0].messages.length-1].details;
			return `${message} - From ${moment.utc(this.props.status.maintenance.active[0].datetime_planned_start).format('LLLL')} to ${moment.utc(this.props.status.maintenance.active[0].datetime_planned_end).format('LLLL')} UTC`;
		}
		if (statusType === 'upcoming') {
			message = this.props.status.maintenance.upcoming[0].messages[this.props.status.maintenance.upcoming[0].messages.length-1].details;
			return `${message} - From ${moment.utc(this.props.status.maintenance.upcoming[0].datetime_planned_start).format('LLLL')} to ${moment.utc(this.props.status.maintenance.upcoming[0].datetime_planned_end).format('LLLL')} UTC`;
		}
	}

	render() {
		return (
			<div className={this.state.isShowStatus ? 'showtix-status is-active': 'showtix-status'}>
				<div className="container">
					<button
						onClick={() => this.closeStatus()}
					>
						&times;
					</button>
					<a href="http://status.showtix4u.com" target="_blank">
						<span>{this.renderTitle()}</span>
						{this.renderMessage()}
					</a>
				</div>
			</div>
		);
	}
}

export default withRouter(Status);

Status.propTypes = {
    isShowStatus: PropTypes.bool,
};


// WEBPACK FOOTER //
// ./src/components/Status/Status.js